import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Mail, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10 py-12">
      <div className="container mx-auto px-6 md:px-12">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="text-2xl font-bold text-white mb-4">
              ADK <span className="text-gold">Creative</span>
            </h3>
            <p className="text-gray-400 leading-relaxed mb-6">
              Markaların dijital dünyada daha güçlü görünmesi için modern, sade ve hedef odaklı tasarımlar üretiyoruz.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/adkcreative"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 bg-white/5 border border-white/10 rounded-xl hover:bg-gold hover:border-gold hover:scale-110 transition-all duration-300 group"
              >
                <Instagram className="w-5 h-5 text-gray-400 group-hover:text-black transition-colors" />
              </a>
              <a
                href="mailto:ahmetdemirkesen81@gmail.com"
                className="p-3 bg-white/5 border border-white/10 rounded-xl hover:bg-gold hover:border-gold hover:scale-110 transition-all duration-300 group"
              >
                <Mail className="w-5 h-5 text-gray-400 group-hover:text-black transition-colors" />
              </a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="text-white font-semibold mb-6">Hızlı Erişim</h4>
            <ul className="space-y-3">
              {['Ana Sayfa', 'Hakkımızda', 'Hizmetler', 'Paketler', 'Portfolio', 'S.S.S', 'İletişim'].map((item, idx) => {
                const hrefs = ['#home', '#about', '#services', '#paketler', '#portfolio', '#sss', '#teklif-formu'];
                return (
                  <li key={item}>
                    <a
                      href={hrefs[idx]}
                      className="text-gray-400 hover:text-gold transition-colors duration-300 inline-block"
                    >
                      {item}
                    </a>
                  </li>
                );
              })}
            </ul>
          </motion.div>

          {/* Services */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="text-white font-semibold mb-6">Hizmetlerimiz</h4>
            <ul className="space-y-3">
              {[
                'Logo Tasarım',
                'Kurumsal Kimlik',
                'Sosyal Medya Tasarım',
                'Baskı Tasarımları',
                'Ambalaj Tasarımı',
                'Marka Danışmanlığı',
              ].map((service) => (
                <li key={service}>
                  <span className="text-gray-400">{service}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col md:flex-row justify-between items-center gap-4"
          >
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} ADK Creative. Tüm hakları saklıdır.
            </p>
            
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <span>Made with</span>
              <Heart className="w-4 h-4 text-gold fill-gold" />
              <span>in Bartın</span>
            </div>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
